import React from "react";
import "../OpalAccountInfoDetails.css";

const OpalAccountCategorization = ({ data }) => {
    return (
        <div className="opal-info-details">
            <div className="opal-row">
                <div className="opal-cell label">Specialization</div>
                <div className="opal-cell value">
                    {data?.specialization && data?.specialization.length > 0 && data?.specialization.map(item => item?.description).join(", ")}
                </div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Practice</div>
                <div className="opal-cell value">{data?.practice?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Classification</div>
                <div className="opal-cell value">{data?.classification?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Influence</div>
                <div className="opal-cell value">{data?.influence?.description}</div>
            </div>
        </div>
    );
};

export default OpalAccountCategorization;
